import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { CountryService } from "../service/country.service";
import { ApiRequestService } from "../service/api-request.service";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { environment as env } from "../../environments/environment";
import * as moment from 'moment'
import * as crypto from 'crypto-js';

@Component({
  selector: "home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  date: Date = new Date();
  settings = {
    bigBanner: true,
    timePicker: false,
    format: "dd-MM-yyyy",
    defaultOpen: true,
  };
  // Ng Models
  campaingId: any = 0;
  transactionName: any;
  transactionPhone: any;
  transactionEmail: any;
  public invoiceTaxRegimen: any = "";
  transactionLastName: any;
  customAmountDonation: any = "";
  showGamecashMsg: string;
  voucherProsecutor: any = false;
  selectedPlan: any = "default";
  selectedPlanChangeName: any = "";
  selectedPlanChangeAmount: any = "";
  public errorTaxRegimen: boolean = false;
  showChangeorg: boolean = false;
  showGamecashModal: boolean;
  transactionCreditDebit: any;
  transactionCardBrand: any;
  transactionAmount: any;
  isCustomDonation: boolean;
  showGamecashErrorModal: boolean;
  donorAmountPlan: any;
  donorAmount: any = 0;
  selectedAmountText: any;
  amountTextPlan: any;
  public errorZipCodeRedPay: boolean;
  public errorAddressRedPay: boolean;
  public addressRedPay: any = '';
  public zipCodeRedPay: any = '';
  public gateway: any;
  amountListFixed: any = [];
  amountListFixedText: any = [];
  amountTextList: any = [];
  amountListPlan: any = [];
  invoiceStreet: any;
  invoiceExt: any;
  invoiceInt: any;
  invoiceZipCode: any;
  invoiceCountry: any = "MX";
  invoiceGender: any = "male";
  invoiceDate: any;
  invoiceRfc: any = "";
  invoiceRs: any = "";
  invoiceEmail: any = "";
  invoiceState: any;
  gamecashPDF: any;
  gamecash: boolean;
  invoiceCity: any;
  invoiceColony: any;
  invoiceMunicipality: any;
  // professionDonor: any = "";
  transactionPlanId: any = "";
  transactionCampaingId: any;
  savePersonId: any;
  transactionId: any;
  campaingName: any;
  urlIsFromFacebook: boolean = false;
  authTokenAccess: string;
  // Second Step
  transactionCardNumber: any;
  transactionCardHolder: any;
  transactionExpMonth: any = "";
  transactionExpYear: any = "";
  transactionCvv: any;
  transactionPrivacy: any = false;
  typeFormCard: any;
  typeFormSelect: any = "";
  numTypeDoc: any = "";
  showTypeFormCard: boolean = false;
  showTxtIbero: boolean = false;
  documentTypeOptions: any;
  // Errors errorExpMonth
  errorCampaing: boolean = false;
  errorAmount: boolean = false;
  errorEmail: boolean = false;
  errorName: boolean = false;
  errorLastName: boolean = false;
  errorPhone: boolean = false;
  errorEmpty: boolean = false;
  invalidMail: boolean = false;
  invalidPhone: boolean = false;
  invalidCard: boolean = false;
  invalidCcv: boolean = false;
  errorCart: boolean = false;
  errorCartHolder: boolean = false;
  errorExpMonth: boolean = false;
  errorExpYear: boolean = false;
  errorCcv: boolean = false;
  errorPrivacy: boolean = false;
  errorStreet: boolean = false;
  errorStreetNumber: boolean = false;
  errorCountry: boolean = false;
  errorZipCode: boolean = false;
  errorColony: boolean = false;
  errorSex: boolean = false;
  errorDate: boolean = false;
  errorRfc: boolean = false;
  errorRs: boolean = false;
  errorPaypal: any;
  paypalError: boolean = false;
  customError: string;
  fiscalData: boolean = false;
  errorCaptcha: boolean = false;
  paypalHide: boolean = true;
  homeStepOne: boolean = false;
  homeStepTwo: boolean = false;
  homeStepThree: boolean = false;
  congratulationHide: boolean = false;
  errorDeclinedHide: boolean = false;
  errorPayment: boolean = false;
  errorPaymentText: any = "";
  // transactions button
  transactionStatus: any;
  loaderStatus: any = false;
  loaderStepThreeTransaction: boolean = false;
  transactionStatusButtonDonate: boolean = true;
  transactionStatusButtonWait: boolean = false;
  transactionStatusButtonError: boolean = false;
  transactionStatusButtonRetry: boolean = false;
  uniqueDonation: boolean = true;
  recurringDonation: boolean = true;
  uniqueDonationHide: boolean = false;
  recurringDonationHide: boolean = true;
  homeCartContainer: boolean = true;
  homeCartContainerCvv: boolean = false;
  cardCvv: boolean = false;
  cardNumber: boolean = false;
  cardMonthYear: boolean = false;
  homeStyles: any = [];
  homeFooter: any = [];
  homeBackground: any = [];
  homeBackgroundOriginal: any = [];
  homeBackground2: any = [];
  homeBackground3: any = [];
  homeAlign: any;
  homeTextFormStep1: any = [];
  homeTextFormStep2: any = [];
  homeTextFormStep3: any = [];
  homeTextFormStep4: any;
  homeImgCongratulationStep4: string;
  planList: any = [];
  campaigList: any = [];
  countriesList: any = [];
  showAmountText: any;
  merchant: any;
  getMerchant: any;
  uniqueRecurring: any;
  showOxxoLoader: boolean;
  showSpeiLoader: boolean;

  // specific card
  specificCard: boolean = true;
  specificCardVisa: boolean = false;
  specificCardMaster: boolean = false;
  specificCardAmerican: boolean = false;
  //Loader
  isLoaderActive: boolean = true;
  // Welcome view
  welcomeName: any;
  welcomeLastName: any;
  welcomeMessage: any;
  // Choose view
  isOnAlwaysOn: boolean = false;
  isOnAlwaysHome: boolean = false;
  isOnAlwaysNoticePrivacy: boolean = false;
  isOnAlwaysTermsAndConditions: boolean = false;
  isIframeActive: boolean = false;
  // Currency
  currency: any;
  // Production mode
  isProductionMode: boolean = false;
  // Form group
  checkoutForm: FormGroup;
  //Is Prodh
  englishProdh: boolean = false;
  spanishProdh: boolean = false;
  assetLenguageEs: boolean = true;
  isProdh: boolean = false;
  //Regex validation
  emailRegex: any = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  rfcRegex: any = /^([aA-zZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))((-)?([aA-zZ\d]{3}))?$/;
  // Loader transaction
  showLoaderTransaction: boolean = false;
  // Footer social networks
  socialNetworkFooter: any;
  hasFacebookNetwork: boolean = false;
  urlFacebookNetwork: string;
  hasTwitterNetwork: boolean = false;
  urlTwitterNetwork: string;
  hasInstagramNetwork: boolean = false;
  urlInstagramNetwork: string;
  hasYoutubeNetwork: boolean = false;
  urlYoutubeNetwork: string;
  hasGooglePNetwork: boolean = false;
  urlGooglePNetwork: string;
  hasPinterestNetwork: boolean = false;
  urlPinterestNetwork: string;
  hasLinkedinNetwork: boolean = false;
  urlLinkedinNetwork: string;
  hasHomeNetwork: boolean = false;
  urlHomeNetwork: string;
  hasOxxoNetwork: boolean = false;
  urlOxxoNetwork: string;
  hasOtherWays: boolean = false;
  urlOtherWays: string;
  // Show data in card
  showCvvCard: string;
  showCardNumber: string;
  // Thank you modal
  thankYouTransactionNumber: any;
  thankYouCardNumber: any;
  thankYouCardType: any;
  // Modals
  goToHomeModal: boolean = false;
  //Re-captcha
  captchaApproved: string = "";
  // Paypal
  loaderPaypalStatus: any = false;
  paypalRecurrent: boolean = false;
  urlPaypalRecurrent: any;
  savePalpayData: any = [];
  campaignId: any;
  savePaypalTransactionId: any;
  savePaypalPersonId: any;
  savePaypalCampaignId: any;
  savePaypalEmail: any;
  completePayment: any;
  transactionPaypalStatus: any;
  errorDonatePaypalCont: boolean = false;
  errorPaypalDonate: any;
  paymenthPaypal: boolean = false;
  paymenthCredit: boolean = true;
  numberCard: any;
  detectCard: any;
  logoTypeCardVisa: boolean = false;
  logoTypeCardMaster: boolean = false;
  showUniqueTransactionId: any;
  paypalWasRender: boolean = false;
  IsAzul: boolean = true;
  public taxRegimens: any = [];
  public UPmerchants = ['recaudiastr'];

  constructor(
    private countryService: CountryService,
    private apiRequestsService: ApiRequestService
  ) {
    let afavordelnino: any = location.href.split("/")[3];
    if (afavordelnino === 'afavordelnino') {
      this.assetLenguageEs = false;
    }
  }

  ngOnInit() {
    let _ = this;
    _.reviewEnviroment();
    _.checkoutValidationForm();
    _.isCentroProdh();
    _.correctPaymentPaypal();
    _.isIframeSubDomain();
    _.documentType();
    _.generateToken();
  }

  isIframeSubDomain() {
    const _ = this;
    let subdomain: any = location.href;
    if (subdomain.includes("mini-alwayson")) {
      _.isIframeActive = true;
      _.addUneteAnalyticsScript();
      _.addUneteAnalyticsTracker();
    }
  }

  ngAfterViewInit() {
    let _ = this;
    let isTecdlal: any = location.href.split("/");

    if (isTecdlal[3] == "tecdlal" && window.innerWidth <= 500) {
      _.changeBgTecdlal();
    }
  }

  changeBgTecdlal() {
    let _ = this;
    let bgToChange: any = document.querySelector(
      ".homeContainerInformation"
    ) as HTMLElement;
    bgToChange.classList.add("justTecdlal");
  }

  isCentroProdh() {
    let _ = this;
    let parseUrl: any = location.href.split("/");
    if (parseUrl[3] == "centroprodh") {
      _.englishProdh = false;
      _.spanishProdh = true;
      _.isProdh = true;
      return;
    }
    if (parseUrl[3] == "centroprodhusd") {
      _.englishProdh = true;
      _.spanishProdh = false;
      _.isProdh = true;
      return;
    }
    _.englishProdh = false;
    _.spanishProdh = false;
    _.isProdh = false;
  }

  payWithGamecash(type): void {
    let amountQuantity: any =
    this.customAmountDonation != 0 && this.isCustomDonation
      ? this.customAmountDonation
      : this.donorAmount;
    amountQuantity = !this.isCustomDonation
      ? amountQuantity.split(" ")[0]
      : this.customAmountDonation;
    let test = amountQuantity.toString();
    if (test.includes(",")) {
      amountQuantity = amountQuantity.replace(",", "");
    }

    if (type === 'oxxo') {
      this.showOxxoLoader = true;
    } else {
      this.showSpeiLoader = true;
    }
    const params = {
      transaction:{
        campaign_id: this.transactionCampaingId,
        amount: amountQuantity.toString() || this.transactionAmount.split(" ")[0],
        person_id: this.savePersonId,
        type
      },
      merchant: this.merchant
    };

    this.apiRequestsService.payWithGamecash(params).subscribe( data => {
      this.showGamecashModal = true;
      this.showGamecashMsg = data['msg'];
      this.gamecashPDF = data['results'].url;
      this.showOxxoLoader = false;
      this.showSpeiLoader = false;
    }, err => {
      this.showGamecashMsg = err.msg;
      this.showOxxoLoader = false;
      this.showSpeiLoader = false;
      this.showGamecashErrorModal = true;
    });
  }

  checkoutValidationForm() {
    let _ = this;
    _.checkoutForm = new FormGroup({
      //Step one
      emailHomeInput: new FormControl("emailHomeInput", Validators.required),
      nameHomeInput: new FormControl("nameHomeInput", Validators.required),
      lastNameHomeInput: new FormControl(
        "lastNameHomeInput",
        Validators.required
      ),
      phoneHomeInput: new FormControl("phoneHomeInput", Validators.required),
      // Step two
      cardNumberHomeInput: new FormControl(
        "cardNumberHomeInput",
        Validators.required
      ),
      cardNameHomeInput: new FormControl(
        "cardNameHomeInput",
        Validators.required
      ),
      secretInputControl: new FormControl(
        "secretInputControl",
        Validators.required
      ),
      addressRedPay: new FormControl(
        "addressRedPay"
      ),
      zipCodeRedPay: new FormControl(
        "zipCodeRedPay"
      ),
      // Step three
      postalCodeControl: new FormControl(
        "postalCodeControl",
        Validators.required
      ),
      streetHomeInput: new FormControl("streetHomeInput", Validators.required),
      noExtHomeInput: new FormControl("noExtHomeInput", Validators.required),
      noIntHomeInput: new FormControl("noIntHomeInput", Validators.required),
      colonyHomeInput: new FormControl("colonyHomeInput", Validators.required),
      dateHomeInput: new FormControl("dateHomeInput", Validators.required),
      rfcHomeInput: new FormControl("rfcHomeInput", Validators.required),
      tax_regime: new FormControl("tax_regime", Validators.required),
      companyHomeInput: new FormControl(
        "companyHomeInput",
        Validators.required
      ),
      fiscalEmailHomeInput: new FormControl(
        "fiscalEmailHomeInput",
        Validators.required
      ),
      // professionHomeInput: new FormControl(
      //   "professionHomeInput",
      //   Validators.required
      // ),
    });
  }

  reviewEnviroment() {
    let _ = this;
    let donateUrl = location.href;
    let isDevEnviroment = donateUrl.indexOf("dev");
    if (isDevEnviroment != -1) {
      _.isProductionMode = true;
    }
  }

  async whereIam() {
    let _ = this;
    let homePosition;
    let lenguageForm;
    let getUrl: any = location.href;
    getUrl = getUrl.split("/");
    let legalWarning = getUrl[4];
    getUrl = getUrl[3];
    _.urlIsFromFacebook =
      getUrl.includes("fb") || getUrl.includes("utm_source");
    getUrl = getUrl.includes("?") ? getUrl.split("?")[0] : getUrl;
    if (legalWarning == "terminos-y-condiciones") {
      _.isOnAlwaysNoticePrivacy = false;
      _.isOnAlwaysOn = false;
      _.isOnAlwaysHome = false;
      _.isOnAlwaysTermsAndConditions = true;
      setTimeout(() => {
        _.isLoaderActive = false;
      }, 3200);
      return;
    }
    if (legalWarning == "aviso-de-privacidad") {
      _.isOnAlwaysNoticePrivacy = true;
      _.isOnAlwaysOn = false;
      _.isOnAlwaysHome = false;
      _.isOnAlwaysTermsAndConditions = false;
      setTimeout(() => {
        _.isLoaderActive = false;
      }, 3200);
      return;
    }
    if (getUrl == "") {
      _.isOnAlwaysOn = false;
      _.isOnAlwaysHome = true;
      _.isOnAlwaysNoticePrivacy = false;
      _.isOnAlwaysTermsAndConditions = false;
      setTimeout(() => {
        _.isLoaderActive = false;
      }, 1000);
      return;
    }

    if (getUrl != "") {
      _.isOnAlwaysOn = true;
      _.isOnAlwaysHome = false;
      _.isOnAlwaysNoticePrivacy = false;
      _.isOnAlwaysTermsAndConditions = false;
      _.getMerchant = getUrl;
      _.merchant = _.getMerchant;
      _.getPlanId(_.merchant);
      _.getCampaingId(_.merchant);
      _.getCountries();

      if (getUrl == "centroprodhusd") {
        _.currency = "USD";
        lenguageForm = "en";
        _.selectedPlan = "-select an amount-";
      }
      if (_.assetLenguageEs) {
        lenguageForm = "es";
      } else {
        lenguageForm = 'en'
      }

      await _.apiRequestsService.getDesign(getUrl).subscribe(
        (data) => {
          if (getUrl === "ibero") {
            this.showTxtIbero = true;
          }
          _.homeStyles = data["results"][0]["_configuration"]["design"];
          if (
            getUrl === "azul" ||
            (getUrl === "azulfen" && _.isIframeActive === true)
          ) {
            _.homeStyles.background_form = "2, 0, 99, 0.5";
          }
          _.homeFooter = data["results"][0]["_configuration"]["footer"];
          _.socialNetworkFooter =
            data["results"][0]["_configuration"]["footer"].social_networks;
          _.homeAlign = data["results"][0]["_configuration"]["design"].align;
          _.uniqueRecurring =
            data["results"][0]["_configuration"]["design"].color_button;
          _.amountListFixed = data["results"][0]["amounts"];
          _.howSocialNetwork();
          _.homeBackgroundOriginal =
            data["results"][0]["_configuration"]["design"]["images"][
              lenguageForm
            ][0];
          _.homeBackground2 =
            data["results"][0]["_configuration"]["design"]["images"][
              lenguageForm
            ][1];
          _.homeBackground3 =
            data["results"][0]["_configuration"]["design"]["images"][
              lenguageForm
            ][2];
          _.homeBackground = _.homeBackgroundOriginal;
          _.paypalHide = data["results"][0]["payment_methods"].paypal;
          _.gateway = data["results"][0]["payment_methods"].gateway;
          _.gamecash = data["results"][0]["payment_methods"].gamecash;
          _.homeTextFormStep1 =
            data["results"][0]["_configuration"]["form"][lenguageForm]["step1"];
          _.homeTextFormStep2 =
            data["results"][0]["_configuration"]["form"][lenguageForm]["step2"];
          _.homeTextFormStep3 =
            data["results"][0]["_configuration"]["form"][lenguageForm]["step3"];
          _.homeTextFormStep4 =
            data["results"][0]["_configuration"]["form"][lenguageForm][
              "step4"
            ].thanks_message;
          _.homeImgCongratulationStep4 =
            data["results"][0]["_configuration"]["form"][lenguageForm][
              "step4"
            ].thank_image;
          _.typeFormCard = data["results"][0].typeFormCard;
          _.currency = data["results"][0]["currency"][0].currency;
          document.title = data["results"][0].merchant_name;
          homePosition = document.getElementById("homeAlignClass");
          this.getTaxRegimens();
          if (_.typeFormCard === 2) {
            this.showTypeFormCard = true;
          }
          if (_.completePayment == undefined || _.urlIsFromFacebook) {
            setTimeout(() => {
              _.isLoaderActive = false;
            }, 1000);
          }
          if (_.homeAlign == "left") {
            homePosition.classList.remove("checkoutCenter");
            homePosition.classList.add("checkoutLeft");
            return;
          }
          if (_.homeAlign == "right") {
            homePosition.classList.remove("checkoutCenter");
            homePosition.classList.add("checkoutRight");
            return;
          }
        },
        (err) => {
          location.href = "/";
        }
      );
    }
  }

  howSocialNetwork() {
    let _ = this;
    for (var i = 0; i < _.socialNetworkFooter.length; i++) {
      if (_.socialNetworkFooter[i].name == "facebook") {
        _.hasFacebookNetwork = true;
        _.urlFacebookNetwork = _.socialNetworkFooter[i].url;
      }

      if (_.socialNetworkFooter[i].name == "twitter") {
        _.hasTwitterNetwork = true;
        _.urlTwitterNetwork = _.socialNetworkFooter[i].url;
      }

      if (_.socialNetworkFooter[i].name == "instagram") {
        _.hasInstagramNetwork = true;
        _.urlInstagramNetwork = _.socialNetworkFooter[i].url;
      }

      if (_.socialNetworkFooter[i].name == "youtube") {
        _.hasYoutubeNetwork = true;
        _.urlYoutubeNetwork = _.socialNetworkFooter[i].url;
      }

      if (_.socialNetworkFooter[i].name == "google_plus") {
        _.hasGooglePNetwork = true;
        _.urlGooglePNetwork = _.socialNetworkFooter[i].url;
      }

      if (_.socialNetworkFooter[i].name == "pinterest") {
        _.hasPinterestNetwork = true;
        _.urlPinterestNetwork = _.socialNetworkFooter[i].url;
      }

      if (_.socialNetworkFooter[i].name == "linkedin") {
        _.hasLinkedinNetwork = true;
        _.urlLinkedinNetwork = _.socialNetworkFooter[i].url;
      }

      if (_.socialNetworkFooter[i].name == "home") {
        _.hasHomeNetwork = true;
        _.urlHomeNetwork = _.socialNetworkFooter[i].url;
      }

      if (_.socialNetworkFooter[i].name == "otros") {
        _.hasOtherWays = true;
        _.urlOtherWays = _.socialNetworkFooter[i].url;
      }

      if (_.socialNetworkFooter[i].name == "oxxo") {
        _.hasOxxoNetwork = true;
        _.urlOxxoNetwork = _.socialNetworkFooter[i].url;
      }
    }
  }

  getAllAmountButtons(index) {
    let _ = this;
    _.showAmountText = _.amountListFixed[index].reward;
  }

  getBackground() {
    let _ = this;
    if (_.homeStepOne) {
      _.homeBackground = _.homeBackground;
    }
    if (_.homeStepTwo) {
      _.homeBackground = _.homeBackground2;
    }
    if (_.homeStepThree) {
      _.homeBackground = _.homeBackground3;
    }
  }

  public getTaxRegimens(): void {
    const parmas = {
      merchant: this.merchant
    };
    this.apiRequestsService.getTaxRegimens(parmas).subscribe(data => {
      this.taxRegimens = data['results'];
    });
  }

  getPlanId(merchant) {
    let _ = this;
    _.merchant = _.getMerchant;
    _.apiRequestsService.getPlan(_.merchant).subscribe((data) => {
      if (_.merchant === "changeorg") {
        _.showChangeorg = true;
        _.selectedPlan = 2;
        _.planList = data;
        _.donorAmountPlan = _.planList.results[2].amount;
        _.isCustomDonation = false;
        _.donorAmountPlan = _.donorAmountPlan.split(".");
        _.donorAmountPlan = _.donorAmountPlan[0];
        _.transactionPlanId = _.planList.results[2].plan_id;
        _.donorAmount = _.donorAmountPlan;
      }
      _.planList = data;
    });
  }

  getSelectedPlanId() {
    let _ = this;
    _.transactionPlanId = _.planList.results[_.selectedPlan].plan_id;
    _.amountTextPlan = _.planList.results[_.selectedPlan].description;
  }

  getCampaingId(merchant) {
    let _ = this;
    _.merchant = _.getMerchant;
    _.apiRequestsService.getCampaing(_.merchant).subscribe((data) => {
      _.campaigList = data;
      _.transactionCampaingId = _.campaigList.results[_.campaingId].campaign_id;
    });
  }

  getSelectedCampaingId() {
    let _ = this;
    _.transactionCampaingId = _.campaigList.results[_.campaingId].campaign_id;
    _.campaingName = _.campaigList.results[_.campaingId].name;
  }

  changeLanguage() {
    let _ = this;
    _.assetLenguageEs = !_.assetLenguageEs;
    _.recurringDonationHide = true;
    _.uniqueDonationHide = false;
    _.whereIam();
  }

  validateStepOne() {
    let _ = this;
    let circleBtn2 = document.getElementById("cicleStep2Active");
    let amountQuantity =
      _.customAmountDonation != 0 && _.isCustomDonation
        ? _.customAmountDonation
        : _.donorAmount;
    let transactionData = {
      transactionCampaingId: _.transactionCampaingId,
      customAmountDonation: _.customAmountDonation,
    };
    let invoiceData = { email: _.transactionEmail };
    if (_.transactionCampaingId == undefined || _.transactionCampaingId == "") {
      _.errorCampaing = true;
      _.errorAmount = false;
      _.errorEmpty = true;
      _.errorEmail = false;
      _.invalidMail = false;
      _.errorName = false;
      _.errorLastName = false;
      _.errorPhone = false;
      _.invalidPhone = false;
      return false;
    }
    if (amountQuantity == "" || amountQuantity == undefined) {
      _.errorCampaing = false;
      _.errorAmount = true;
      _.errorEmpty = false;
      _.errorEmail = false;
      _.invalidMail = false;
      _.errorName = false;
      _.errorLastName = false;
      _.errorPhone = false;
      _.invalidPhone = false;
      return false;
    }
    if (_.transactionEmail == "" || _.transactionEmail == undefined) {
      _.errorCampaing = false;
      _.errorAmount = false;
      _.errorEmpty = true;
      _.errorEmail = true;
      _.invalidMail = false;
      _.errorName = false;
      _.errorLastName = false;
      _.errorPhone = false;
      _.invalidPhone = false;
      return false;
    }
    if (!_.emailValidation(_.transactionEmail)) {
      _.errorCampaing = false;
      _.errorAmount = false;
      _.errorEmpty = false;
      _.errorEmail = true;
      _.invalidMail = true;
      _.errorName = false;
      _.errorLastName = false;
      _.errorPhone = false;
      _.invalidPhone = false;
      return false;
    }
    if (_.transactionName == "" || _.transactionName == undefined) {
      _.errorCampaing = false;
      _.errorAmount = false;
      _.errorEmpty = true;
      _.errorEmail = false;
      _.invalidMail = false;
      _.errorName = true;
      _.errorLastName = false;
      _.errorPhone = false;
      _.invalidPhone = false;
      return false;
    }
    if (_.transactionLastName == "" || _.transactionLastName == undefined) {
      _.errorCampaing = false;
      _.errorAmount = false;
      _.errorEmpty = true;
      _.errorEmail = false;
      _.invalidMail = false;
      _.errorName = false;
      _.errorLastName = true;
      _.errorPhone = false;
      _.invalidPhone = false;
      return false;
    }
    if (_.transactionPhone == "" || _.transactionPhone == undefined) {
      _.errorCampaing = false;
      _.errorAmount = false;
      _.errorEmpty = true;
      _.errorEmail = false;
      _.invalidMail = false;
      _.errorName = false;
      _.errorLastName = false;
      _.errorPhone = true;
      _.invalidPhone = false;
      return false;
    }
    if (!_.validatePhoneNumber(_.transactionPhone)) {
      _.errorCampaing = false;
      _.errorAmount = false;
      _.errorEmpty = false;
      _.errorEmail = false;
      _.invalidMail = false;
      _.errorName = false;
      _.errorLastName = false;
      _.errorPhone = true;
      _.invalidPhone = true;
      return false;
    }
    let personData = {
      donor: {
        email: _.transactionEmail,
        name: _.transactionName,
        lastname: _.transactionLastName,
        phone: _.transactionPhone.toString(),
      },
      merchant: _.merchant,
    };
    _.showLoaderTransaction = true;
    _.apiRequestsService.sendPersonData(personData, this.authTokenAccess).subscribe((data) => {
      _.savePersonId = data["results"][0].person_id;
      _.homeStepOne = false;
      _.homeStepTwo = true;
      circleBtn2.style.background = "rgb(" + _.uniqueRecurring + ")";
      circleBtn2.style.color = "#fff";
      _.errorCampaing = false;
      _.errorEmpty = false;
      _.errorEmail = false;
      _.invalidMail = false;
      _.errorName = false;
      _.errorLastName = false;
      _.errorPhone = false;
      _.invalidPhone = false;
      _.showLoaderTransaction = false;
      _.getBackground();

      setTimeout(() => {
        _.showPaypal();
      }, 1);
    });
    _.transactionAmount = amountQuantity;
  }

  sendEmailPaypal() {
    let _ = this;
    let t = new Date();
    let presentDay =
      t.getDate() + "-" + (t.getMonth() + 1) + "-" + t.getFullYear();
    let amountQuantity =
      _.customAmountDonation != 0 && _.isCustomDonation
        ? _.customAmountDonation
        : _.donorAmount;
    let emailData = {
      email: {
        to: _.transactionEmail, // Mandatory field
        email_type: 2, // Mandatory field
        fecha: presentDay.toString(), // Mandatory field
        name: _.transactionName + " " + _.transactionLastName, // Mandatory field
        causa: _.campaingName, // Mandatory field
        transaction_id: _.transactionId, // Mandatory field
        amount: amountQuantity.toString(), // Mandatory field
        recurrente: " ",
      },
      merchant: _.merchant,
    };
    _.apiRequestsService.sendEmailData(emailData).subscribe((data) => {});
  }

  returnStep() {
    const _ = this;
    let circleBtn1 = document.getElementById("cicleStep1Active");
    let circleBtn2 = document.getElementById("cicleStep2Active");
    let inputStepOne: any;
    let labelStepOne: any;
    _.homeStepOne = true;
    _.homeStepTwo = false;
    _.homeBackground = _.homeBackgroundOriginal;
    circleBtn1.style.background = "rgb(" + _.uniqueRecurring + ")";
    circleBtn2.style.background = "rgb(255, 255, 255)";
    circleBtn2.style.color = "#fff";
    _.getBackground();
  }

  resolved(captchaResponse: string) {
    let _ = this;
    _.captchaApproved = captchaResponse;
    _.errorCaptcha = captchaResponse !== '' ? false : true;
  }

  validateStepTwo() {
    let _ = this;
    let botonEnviar = document.getElementById("donar-button");
    botonEnviar["disabled"] = true;
    let circleBtn3 = document.getElementById("cicleStep3Active");
    let joinYearExp = "20" + _.transactionExpYear.toString();
    let joinMonthV = _.transactionExpMonth.toString();
    joinMonthV < 10 ? (joinMonthV = "0" + joinMonthV) : joinMonthV;

    if (_.transactionCardNumber == "" || _.transactionCardNumber == undefined) {
      botonEnviar["disabled"] = false;
      _.errorCart = true;
      _.errorCartHolder = false;
      _.errorExpMonth = false;
      _.errorExpYear = false;
      _.errorEmpty = true;
      _.invalidCard = false;
      _.errorPrivacy = false;
      _.errorCcv = false;
      _.loaderStatus = false;
      return;
    }
    if (!_.numberValidation(_.transactionCardNumber)) {
      botonEnviar["disabled"] = false;
      _.invalidCard = true;
      _.errorPrivacy = false;
      _.invalidCcv = false;
      _.loaderStatus = false;

      return;
    }
    if (_.transactionCardHolder == "" || _.transactionCardHolder == undefined) {
      botonEnviar["disabled"] = false;
      _.errorCart = false;
      _.errorCartHolder = true;
      _.errorExpMonth = false;
      _.errorExpYear = false;
      _.errorEmpty = true;
      _.invalidCard = false;
      _.errorPrivacy = false;
      _.errorCcv = false;
      _.loaderStatus = false;
      return;
    }
    if (
      _.transactionExpMonth == "" ||
      _.transactionExpMonth == undefined ||
      joinMonthV > 12
    ) {
      botonEnviar["disabled"] = false;
      _.errorCart = false;
      _.errorCartHolder = false;
      _.errorExpMonth = true;
      _.errorExpYear = false;
      _.errorEmpty = false;
      _.invalidCard = false;
      _.errorPrivacy = false;
      _.errorCcv = false;
      _.loaderStatus = false;
      return;
    }
    if (_.transactionExpYear == "" || _.transactionExpYear == undefined) {
      botonEnviar["disabled"] = false;
      _.errorCart = false;
      _.errorCartHolder = false;
      _.errorExpMonth = false;
      _.errorExpYear = true;
      _.errorEmpty = true;
      _.invalidCard = false;
      _.invalidCcv = false;
      _.errorPrivacy = false;
      _.errorCcv = false;
      _.loaderStatus = false;
      return;
    }
    if (_.transactionCvv == "" || _.transactionCvv == undefined) {
      botonEnviar["disabled"] = false;
      _.errorCart = false;
      _.errorCartHolder = false;
      _.errorExpMonth = false;
      _.errorExpYear = false;
      _.errorEmpty = true;
      _.invalidCard = false;
      _.invalidCcv = false;
      _.errorPrivacy = false;
      _.errorCcv = true;
      _.loaderStatus = false;
      return;
    }

    if (!_.numberValidation(_.transactionCvv)) {
      botonEnviar["disabled"] = false;
      _.invalidCcv = true;
      _.errorPrivacy = false;
      _.invalidCard = false;
      _.loaderStatus = false;

      return;
    }
    if (!_.transactionPrivacy) {
      botonEnviar["disabled"] = false;
      _.errorPrivacy = true;
      _.errorCart = false;
      _.errorEmpty = false;
      _.errorCcv = false;
      _.loaderStatus = false;

      return false;
    }
    if(_.captchaApproved == ''){
      botonEnviar["disabled"] = false;
      _.errorCaptcha = true;
      _.errorCart = false;
      _.errorCartHolder = false;
      _.errorExpMonth = false;
      _.errorExpYear = false;
      _.errorEmpty = false;
      _.invalidCard = false;
      _.invalidCcv = false;
      _.errorPrivacy = false;
      _.errorCcv = false;
      _.loaderStatus = false;
      return;
    }
    _.errorCaptcha = false;
    _.errorCart = false;
    _.errorCartHolder = false;
    _.errorExpMonth = false;
    _.errorExpYear = false;
    _.errorEmpty = false;
    _.invalidCard = false;
    _.invalidCcv = false;
    _.errorPrivacy = false;
    _.errorCcv = false;
    _.loaderStatus = true;
    _.transactionStatusButtonDonate = true;
    _.transactionStatusButtonError = false;
    _.customError = "";
    let amountQuantity: any =
      _.customAmountDonation != 0 && _.isCustomDonation
        ? _.customAmountDonation
        : _.donorAmount;
    amountQuantity = !_.isCustomDonation
      ? amountQuantity.split(" ")[0]
      : _.customAmountDonation;
    let test = amountQuantity.toString();
    if (test.includes(",")) {
      amountQuantity = amountQuantity.replace(",", "");
    }
    if (_.recurringDonationHide == false) {
      _.transactionPlanId = "";
    }
    let transactionData = {
      transaction: {
        campaign_id: _.transactionCampaingId,
        amount: amountQuantity.toString() || _.transactionAmount.split(" ")[0],
        plan_id: _.transactionPlanId,
        person_id: _.savePersonId,
        card_number: _.transactionCardNumber.toString(),
        cardholder: _.transactionCardHolder,
        exp_month: joinMonthV,
        exp_year: joinYearExp,
        cvv: _.transactionCvv,
        ip: "127.0.0.1",
        currency: _.currency,
        device_fingerprint: localStorage.getItem("device_fingerprint"),
        document_type: _.typeFormSelect,
        document_number: _.numTypeDoc,
        response_key: _.captchaApproved
      },
      merchant: _.merchant,
    };

    if (_.gateway === 'redpay') {
      if (_.addressRedPay === "") {
        botonEnviar["disabled"] = false;
        _.errorZipCodeRedPay = false;
        _.errorAddressRedPay = true;
        _.errorCart = false;
        _.errorCartHolder = false;
        _.errorExpMonth = false;
        _.errorExpYear = false;
        _.errorEmpty = true;
        _.invalidCard = false;
        _.errorPrivacy = false;
        _.errorCcv = false;
        _.loaderStatus = false;
        return;
      }
      if (_.zipCodeRedPay === "") {
        botonEnviar["disabled"] = false;
        _.errorZipCodeRedPay = true;
        _.errorAddressRedPay = false;
        _.errorCart = false;
        _.errorCartHolder = false;
        _.errorExpMonth = false;
        _.errorExpYear = false;
        _.errorEmpty = true;
        _.invalidCard = false;
        _.errorPrivacy = false;
        _.errorCcv = false;
        _.loaderStatus = false;
        return;
      }
      transactionData.transaction['street'] = _.addressRedPay;
      transactionData.transaction['zip'] = _.zipCodeRedPay;
    }

    _.apiRequestsService.sendTransaction(transactionData, this.authTokenAccess).subscribe(
      (data) => {
        botonEnviar["disabled"] = false;
        _.loaderStatus = false;
        _.transactionStatus = data["results"][0].transaction_status;
        _.transactionId = data["results"][0].transaction_id;
        _.thankYouTransactionNumber = data["results"][0].transaction_id;
        _.thankYouCardNumber = data["results"][0].last4;
        _.thankYouCardType = data["results"][0].brand;

        if (_.transactionStatus == "Approved") {
          _.homeStepTwo = false;
          _.homeStepThree = true;
          circleBtn3.style.background = "rgb(" + _.uniqueRecurring + ")";
          circleBtn3.style.color = "#fff";
          _.congratulationHide = true;
          _.getBackground();
          if (_.voucherProsecutor) {
            _.fiscalData = true;
          }
          if (_.voucherProsecutor == false) {
            _.fiscalData = false;
            _.congratulationHide = true;
          }
        }
        if (_.transactionStatus == "Declined") {
          _.transactionStatusButtonDonate = false;
          _.transactionStatusButtonError = true;
          _.errorPayment = true;
          _.errorPaymentText =
            "Tu pago fue rechazado, verifica con tu banco e intenta nuevamente";
        }
      },
      (error) => {
        botonEnviar["disabled"] = false;
        _.customError = error["error"].msg;
        _.errorPayment = true;
        _.errorPaymentText = error["error"].msg;
        _.loaderStatus = false;
      }
    );
  }

  closeThanskMessange() {
    let _ = this;
    if (_.voucherProsecutor == false) {
      _.congratulationHide = false;
    }
    if (_.voucherProsecutor) {
      _.congratulationHide = false;
    }
  }

  validationStepThree() {

    console.log('Hey!!', this.fiscalData);
    let _ = this;
    let invoiceData = {
      address: {
        person_id: _.savePersonId,
        // person_id: "per_f117a57a1a7952",
        email: _.invoiceEmail || _.transactionEmail,
        street: _.invoiceStreet,
        tax_regime: _.invoiceTaxRegimen,
        num_ext: _.invoiceExt,
        num_int:
          _.invoiceInt != null && _.invoiceInt != undefined
            ? _.invoiceInt.toString()
            : _.invoiceInt,
        zip: _.invoiceZipCode,
        country: _.invoiceCountry,
        gender: _.invoiceGender,
        birthdate: _.invoiceDate,
        // profession: _.professionDonor,
        rfc: _.invoiceRfc.toString(),
        legal_name: _.invoiceRs.toString(),
        transaction_id: _.transactionId,
        township: _.invoiceMunicipality,
        city: _.invoiceCity,
        state: _.invoiceState,
        locality: _.invoiceColony,
      },
      merchant: _.merchant,
    };

    // Remove this two lines
    // return;

    if(this.fiscalData){
      const controlGroups = ['rfcHomeInput', 'companyHomeInput', 'tax_regime', 'fiscalEmailHomeInput', 'postalCodeControl' ];
      this.checkoutForm.get('tax_regime').setValidators([Validators.required]);
      this.checkoutForm.get('tax_regime').updateValueAndValidity();
      for (const controlName of controlGroups ) {
        if(!this.checkoutForm.get(controlName).valid){
          this.checkoutForm.get(controlName).markAsTouched();
          this.checkoutForm.get(controlName).updateValueAndValidity();
          console.log('Control: ', controlName, ' has error');
          _.loaderStepThreeTransaction = false;
          return;
        }
      }
    }else{
      // Normal type address only field neccesary is zipcode
      if(!this.checkoutForm.get('postalCodeControl').valid){
        this.checkoutForm.get('postalCodeControl').markAsTouched();
        this.checkoutForm.get('postalCodeControl').updateValueAndValidity();
        _.loaderStepThreeTransaction = false;
        return;
      }
    }

    // if (_.invoiceEmail === "") {
    //   _.invoiceEmail = _.transactionEmail;
    // }

    // _.loaderStepThreeTransaction = true;

    // if (
    //   (_.invoiceStreet == "" || _.invoiceStreet == undefined) &&
    //   !_.fiscalData
    // ) {
    //   _.errorStreet = true;
    //   _.errorStreetNumber = false;
    //   _.errorCountry = false;
    //   _.errorZipCode = false;
    //   _.errorColony = false;
    //   _.errorSex = false;
    //   _.errorDate = false;
    //   _.errorEmpty = true;
    //   _.errorTaxRegimen = false;
    //   _.errorRs = false;
    //   _.loaderStepThreeTransaction = false;
    //   return;
    // }
    // if ((_.invoiceExt == "" || _.invoiceExt == undefined) && !_.fiscalData) {
    //   _.errorStreet = false;
    //   _.errorStreetNumber = true;
    //   _.errorCountry = false;
    //   _.errorZipCode = false;
    //   _.errorColony = false;
    //   _.errorSex = false;
    //   _.errorTaxRegimen = false;
    //   _.errorDate = false;
    //   _.errorEmpty = true;
    //   _.errorRs = false;
    //   _.loaderStepThreeTransaction = false;
    //   return;
    // }
    // if (
    //   (_.invoiceCountry == "" || _.invoiceCountry == undefined) &&
    //   !_.fiscalData
    // ) {
    //   _.errorStreet = false;
    //   _.errorStreetNumber = false;
    //   _.errorCountry = true;
    //   _.errorZipCode = false;
    //   _.errorTaxRegimen = false;
    //   _.errorColony = false;
    //   _.errorSex = false;
    //   _.errorDate = false;
    //   _.errorEmpty = true;
    //   _.errorRs = false;
    //   _.loaderStepThreeTransaction = false;
    //   return;
    // }
    // if (_.invoiceZipCode == "" || _.invoiceZipCode == undefined) {
    //   _.errorStreet = false;
    //   _.errorStreetNumber = false;
    //   _.errorCountry = false;
    //   _.errorZipCode = true;
    //   _.errorColony = false;
    //   _.errorTaxRegimen = false;
    //   _.errorSex = false;
    //   _.errorDate = false;
    //   _.errorEmpty = true;
    //   _.errorRs = false;
    //   _.loaderStepThreeTransaction = false;
    //   return;
    // }
    // if (
    //   (_.invoiceColony == "" || _.invoiceColony == undefined) &&
    //   !_.fiscalData
    // ) {
    //   _.errorStreet = false;
    //   _.errorStreetNumber = false;
    //   _.errorCountry = false;
    //   _.errorZipCode = false;
    //   _.errorColony = true;
    //   _.errorTaxRegimen = false;
    //   _.errorSex = false;
    //   _.errorDate = false;
    //   _.errorEmpty = true;
    //   _.errorRs = false;
    //   _.loaderStepThreeTransaction = false;
    //   return;
    // }
    // if (
    //   (_.invoiceGender == "" || _.invoiceGender == undefined) &&
    //   !_.fiscalData
    // ) {
    //   _.errorStreet = false;
    //   _.errorStreetNumber = false;
    //   _.errorCountry = false;
    //   _.errorZipCode = false;
    //   _.errorColony = false;
    //   _.errorTaxRegimen = false;
    //   _.errorSex = true;
    //   _.errorDate = false;
    //   _.errorEmpty = true;
    //   _.errorRs = false;
    //   _.loaderStepThreeTransaction = false;
    //   return;
    // }
    // if ((_.invoiceDate == "" || _.invoiceDate == undefined) && !_.fiscalData) {
    //   _.errorStreet = false;
    //   _.errorStreetNumber = false;
    //   _.errorCountry = false;
    //   _.errorZipCode = false;
    //   _.errorColony = false;
    //   _.errorSex = false;
    //   _.errorDate = true;
    //   _.errorTaxRegimen = false;
    //   _.errorEmpty = true;
    //   _.errorRs = false;
    //   _.loaderStepThreeTransaction = false;
    //   return;
    // }

    // if (
    //   (_.invoiceRfc == "" ||
    //     _.invoiceRfc == undefined ||
    //     !_.validateRfc(_.invoiceRfc)) &&
    //   _.fiscalData
    // ) {
    //   _.errorStreet = false;
    //   _.errorStreetNumber = false;
    //   _.errorCountry = false;
    //   _.errorZipCode = false;
    //   _.errorColony = false;
    //   _.errorTaxRegimen = false;
    //   _.errorSex = false;
    //   _.errorDate = false;
    //   _.errorEmpty = false;
    //   _.errorRfc = true;
    //   _.errorRs = false;
    //   _.loaderStepThreeTransaction = false;
    //   return;
    // }

    // if ((_.invoiceRs == "" || _.invoiceRs == undefined) && _.fiscalData) {
    //   _.errorStreet = false;
    //   _.errorStreetNumber = false;
    //   _.errorCountry = false;
    //   _.errorZipCode = false;
    //   _.errorColony = false;
    //   _.errorTaxRegimen = false;
    //   _.errorSex = false;
    //   _.errorDate = false;
    //   _.errorEmpty = false;
    //   _.errorRfc = false;
    //   _.errorRs = true;
    //   _.loaderStepThreeTransaction = false;
    //   return;
    // }

    // if ((_.invoiceTaxRegimen == "" || _.invoiceTaxRegimen == undefined) && _.fiscalData) {
    //   _.errorStreet = false;
    //   _.errorStreetNumber = false;
    //   _.errorCountry = false;
    //   _.errorZipCode = false;
    //   _.errorColony = false;
    //   _.errorSex = false;
    //   _.errorDate = false;
    //   _.errorEmpty = false;
    //   _.errorRfc = false;
    //   _.errorRs = false;
    //   _.errorTaxRegimen = true;
    //   _.loaderStepThreeTransaction = false;
    //   return;
    // }

    // if (
    //   (_.invoiceEmail == "" ||
    //     _.invoiceEmail == undefined ||
    //     !_.emailValidation(_.invoiceEmail)) &&
    //   _.fiscalData
    // ) {
    //   _.errorStreet = false;
    //   _.errorStreetNumber = false;
    //   _.errorCountry = false;
    //   _.errorTaxRegimen = false;
    //   _.errorZipCode = false;
    //   _.errorColony = false;
    //   _.errorSex = false;
    //   _.errorDate = false;
    //   _.errorEmpty = false;
    //   _.errorRfc = false;
    //   _.errorRs = false;
    //   _.errorEmail = true;
    //   _.loaderStepThreeTransaction = false;
    //   return;
    // }

    console.log('Alles ok!', invoiceData)
    _.errorStreet = false;
    _.errorStreetNumber = false;
    _.errorCountry = false;
    _.errorZipCode = false;
    _.errorColony = false;
    _.errorSex = false;
    _.errorDate = false;
    _.errorEmpty = false;
    _.errorRfc = false;
    _.errorTaxRegimen = false;
    _.errorRs = false;
    _.errorEmail = false;
    _.apiRequestsService.sendInvoiceData(invoiceData).subscribe(
      (data) => {
        _.loaderStepThreeTransaction = false;
        setTimeout(() => {
          window.location.href = `/${_.getMerchant}`;
        }, 1000);
      },
      (err) => {
        _.loaderStepThreeTransaction = false;
      }
    );
  }

  getZipCode(zipCode, merchant) {
    let _ = this;
    _.merchant = _.getMerchant;
    let invoiceData = {
      township: _.invoiceMunicipality,
      city: _.invoiceCity,
      state: _.invoiceState,
      locality: _.invoiceColony,
    };
    _.apiRequestsService.getZipCode(zipCode, _.merchant).subscribe((data) => {
      _.invoiceState = data["results"][0].state;
      _.invoiceCity = data["results"][0].city;
      _.invoiceMunicipality = data["results"][0].municipality;
    });
  }

  getCardDetect(cardNumber, merchant) {
    let _ = this;
    _.merchant = _.getMerchant;
    _.apiRequestsService
      .getCardDetect(cardNumber.toString(), _.merchant)
      .subscribe((data) => {
        _.transactionCreditDebit = data["results"][0].type_card;
        _.transactionCardBrand = data["results"][0].card_brand;
        if (_.transactionCardBrand == "VISA") {
          _.specificCard = false;
          _.specificCardVisa = true;
          _.specificCardMaster = false;
          _.specificCardAmerican = false;
        }
        if (_.transactionCardBrand == "MASTERCARD") {
          _.specificCard = false;
          _.specificCardVisa = false;
          _.specificCardMaster = true;
          _.specificCardAmerican = false;
        }
        if (_.transactionCardBrand == "AMERICAN EXPRESS") {
          _.specificCard = false;
          _.specificCardVisa = false;
          _.specificCardMaster = false;
          _.specificCardAmerican = true;
        }
      });
  }

  validateMyRfc() {
    const _ = this;
    if (!_.validateRfc(_.invoiceRfc)) {
      _.errorRfc = true;
      _.errorEmpty = false;
      return;
    }
    _.errorRfc = false;
  }

  uniqueDonate() {
    const _ = this;
    let uniqueBtn = document.getElementById("unique");
    let recurringBtn = document.getElementById("recurring");
    _.uniqueDonation = true;
    _.recurringDonation = false;
    _.uniqueDonationHide = true;
    _.recurringDonationHide = false;
    recurringBtn.style.background = "rgb(190, 191, 193)";
    uniqueBtn.style.background = "rgb(" + _.uniqueRecurring + ")";
    if (_.merchant === "azul" || _.merchant === "azulfen") {
      setTimeout(() => {
        _.selectOneHundredAmountAzul();
      }, 100);
    }
  }

  recurringDonate() {
    let _ = this;
    let uniqueBtn = document.getElementById("unique");
    let recurringBtn = document.getElementById("recurring");
    _.uniqueDonation = false;
    _.recurringDonation = true;
    _.uniqueDonationHide = false;
    _.recurringDonationHide = true;
    uniqueBtn.style.background = "rgb(190, 191, 193)";
    recurringBtn.style.background = "rgb(" + _.uniqueRecurring + ")";
    _.customAmountDonation = "";
  }

  getCountries() {
    let _ = this;
    _.countriesList = _.countryService.getCountries();
  }

  selectOneHundredAmountAzul() {
    let btnToClick: HTMLElement = document.querySelector(
      '[data-amount-value="100.00"]'
    );
    btnToClick.click();
  }

  changeAmount(e) {
    const _ = this;
    let amountCard = document.querySelectorAll(
      ".amount-card"
    ) as HTMLCollectionOf<HTMLElement>;
    let quantityAmount = e.target.innerText;
    _.customAmountDonation = "";
    _.isCustomDonation = false;
    quantityAmount = quantityAmount.split("$");
    quantityAmount = quantityAmount[1];
    quantityAmount = quantityAmount.split(".");
    quantityAmount = quantityAmount[0];
    _.donorAmount = quantityAmount;
    let target = e.srcElement || e.target;
    let getContentOfTarget = target.classList[1] || target.classList[1];
    if (getContentOfTarget) {
      for (var i = 0; i < amountCard.length; i++) {
        amountCard[i].style.background = "transparent";
        amountCard[i].classList.remove("amountSelected");
      }
      e.target.style.background = "rgb(" + _.uniqueRecurring + ")";
      e.target.classList.add("amountSelected");
    }
    setTimeout(() => {
      _.downPlaceholder("otherAmountPlaceholder", "otherAmountHomeInput");
    }, 100);
  }

  inputAmount() {
    let _ = this;
    let amountCard = document.querySelectorAll(
      ".amount-card"
    ) as HTMLCollectionOf<HTMLElement>;
    let inputAmountCard = document.querySelector(".otherPrice");
    _.isCustomDonation = true;
    for (var i = 0; i < amountCard.length; i++) {
      amountCard[i].style.background = "transparent";
    }
    inputAmountCard.classList.add("selected-amount-input");
  }

  getInputAmount() {
    let amount = (<HTMLInputElement>document.getElementById("quantity-donor"))
      .value;
  }

  planChangeAmount(e) {
    let _ = this;
    _.donorAmountPlan = _.planList.results[_.selectedPlan].amount;
    _.isCustomDonation = false;
    _.donorAmountPlan = _.donorAmountPlan.split(".");
    _.donorAmountPlan = _.donorAmountPlan[0];
    _.donorAmount = _.donorAmountPlan;
  }

  // Regex validation
  emailValidation(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  numberValidation(item) {
    let re = /^\d+$/;
    return re.test(item);
  }

  validateRfc(rfc) {
    var re = /^([aA-zZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))((-)?([aA-zZ\d]{3}))?$/;
    return re.test(rfc);
  }

  validatePhoneNumber(phone) {
    if (phone.toString().length < 10 || phone.toString().length > 15) {
      return false;
    } else {
      let re = /^[\d ()+]+$/;
      return re.test(phone);
    }
  }

  // Paypal API
  donatePaypalRecurrent() {
    const _ = this;
    let paypalRecurrentData = {
      paypal: {
        campaign_id: _.transactionCampaingId, // Required field
        plan_id: _.transactionPlanId, // Required field
        person_id: _.savePersonId, // Required field
      },
      merchant: _.merchant,
    };
    _.apiRequestsService
      .sendPaypalRecurrent(paypalRecurrentData)
      .subscribe((data) => {
        location.href = data["results"]["links"][0].href;
      });
  }

  correctPaymentPaypal() {
    let _ = this;
    let parseData = location.href.split("&");
    for (let i = 0; i < parseData.length; i++) {
      let compressData = parseData[i].split("=");
      let compressBlockData = compressData[1];
      _.savePalpayData.push(compressData);
    }
    _.completePayment = _.savePalpayData[0][1];
    _.whereIam();
    if (_.completePayment == undefined || _.urlIsFromFacebook) {
      localStorage.removeItem("selectedMonthly");
      _.homeStepOne = true;
      return;
    }
    if (_.completePayment == "yes") {
      _.savePersonId = _.savePalpayData[1][1];
      let campaingPaypal = _.savePalpayData[2][1];
      let planIdPaypal = _.savePalpayData[3][1];
      let tokenPaypal = _.savePalpayData[5][1];
      let recurrentPayment = {
        paypal: {
          ba_token: tokenPaypal, // Required field
          campaign_id: campaingPaypal, // Required field
          plan_id: planIdPaypal, // Required field
          person_id: _.savePersonId, // Required field
          declined: false, //  Required field
        },
        merchant: _.merchant,
      };
      _.loaderPaypalStatus = true;
      _.apiRequestsService
        .sendTransactionPaypalRecurrent(recurrentPayment)
        .subscribe((data) => {
          _.thankYouCardType = data["results"][0].method;
          _.transactionId = data["results"][0].reference;
          _.savePaypalPersonId = data["results"][0].person_id;
          _.savePaypalCampaignId = data["results"][0].campaign_id;
          _.transactionEmail = data["results"][0].person_email;
          _.showUniqueTransactionId = data["results"][0].auth_code;
          _.transactionPaypalStatus = data["results"][0].transaction_status;
          if (_.transactionPaypalStatus == "Approved") {
            _.loaderPaypalStatus = false;
            _.homeStepOne = false;
            _.homeStepTwo = false;
            _.homeStepThree = true;
            _.congratulationHide = true;
            _.getBackground();
            if (_.voucherProsecutor) {
              _.fiscalData = true;
            }
            if (_.voucherProsecutor == false) {
              _.fiscalData = false;
              _.congratulationHide = true;
            }
          }
          if (_.transactionPaypalStatus == "Declined") {
            _.homeStepOne = false;
            _.transactionStatusButtonDonate = false;
            _.transactionStatusButtonError = true;
            _.errorDeclinedHide = true;
          }
          setTimeout(() => {
            _.isLoaderActive = false;
          }, 10);
        });
    }
  }

  showPaypal() {
    const _ = this;
    if (!_.paypalWasRender) {
      _.paypalWasRender = true;
      _.transactionAmount =
        _.customAmountDonation != ""
          ? _.customAmountDonation.toString()
          : _.transactionAmount;
      _.transactionAmount = _.transactionAmount.includes("MXN")
        ? _.transactionAmount.split(" ")[0]
        : _.transactionAmount;
      // Render the PayPal button
      (window as any).paypal.Button.render(
        {
          env: env.paypal_env, // 'production' Or 'sandbox'
          locale: "es_MX",
          // Set up the payment:
          style: {
            size: "responsive", // medium | large | responsive
            shape: "rect", // pill | rect
            color: "gold", // gold | blue | silver | black
            label: "checkout",
            tagline: false,
          },

          // 1. Add a payment callback
          payment: function (data, actions) {
            // 2. Make a request to your server
            return actions.request
              .post(env.paypal_create_payment, {
                amount: _.transactionAmount,
                currency: _.currency,
                merchant_id: _.merchant,
                person_id: _.savePersonId, // Aqui va el person_id
                channel_id: "alwayson",
                campaign_id: _.transactionCampaingId, // Aqui la campaña que se seleccionó (hacer endpoint para buscar el camp_aksdjaksd)
              })
              .then(function (res) {
                // 3. Return res.id from the response
                return res.results.id;
              });
          },
          // Execute the payment:
          // 1. Add an onAuthorize callback
          onAuthorize: function (data, actions) {
            // 2. Make a request to your server
            return actions.request
              .post(env.paypal_onauthorize_payment, {
                payment_id: data.paymentID,
                payer_id: data.payerID,
                merchant_id: _.merchant,
                amount: _.transactionAmount,
                currency: _.currency,
                person_id: _.savePersonId,
                concept: _.transactionCampaingId,
                channel_id: "alwayson",
                campaign_id: _.transactionCampaingId, // Aqui la campaña que se seleccionó (hacer endpoint para buscar el camp_aksdjaksd)
              })
              .then(function (res) {
                // 3. Show the buyer a confirmation message.
                // Si es aprobado:
                if (res.results.state === "approved") {
                  _.homeStepTwo = false;
                  _.homeStepThree = true;
                  _.voucherProsecutor = true;
                  _.congratulationHide = true;
                  _.fiscalData = true;

                  //Ocultamos el boton de Pago.
                  _.transactionId = res.results.transaction[0].transaction_id; //transactionId
                  _.sendEmailPaypal();
                  _.savePersonId;
                } else {
                  // Si es denegado
                  _.errorPaypal =
                    res.results.transaction[0].gateway_error_description;
                  _.paypalError = true;
                }
              });
          },
        },
        "#paypal-button"
      );
    }
  }

  //Welcome view
  sendWelcomeForm() {
    let _ = this;
    let welcomeData = {
      name: _.welcomeName,
      lastname: _.welcomeLastName,
      message: _.welcomeMessage,
    };
  }

  upPlaceholder(placeholderId, inputId) {
    let placeholderElement = document.getElementById(placeholderId);
    let inputPlaceholderElement = document.getElementById(inputId);
    placeholderElement.classList.add("upPlaceholder");
    inputPlaceholderElement.focus();
    return;
  }

  downPlaceholder(placeholderId, inputId) {
    let inputPlaceholderElement = <HTMLInputElement>(
      document.getElementById(inputId)
    );
    let placeholderElement = document.getElementById(placeholderId);
    if (inputPlaceholderElement.value == "") {
      placeholderElement.classList.remove("upPlaceholder");
      return;
    }
  }

  justTenDigits() {
    let _ = this;
    if (_.transactionPhone == undefined || _.transactionPhone == null) {
      return;
    }

    if (_.transactionPhone.toString().length > 15) {
      _.transactionPhone = _.transactionPhone.toString().substr(0, 15);
    }
  }

  formatInputCard(e) {
    var target = e.target,
      position = target.selectionEnd,
      length = target.value.length;
    target.value = target.value
      .replace(/[^\dA-Z]/g, "")
      .replace(/(.{4})/g, "$1 ")
      .trim();
    target.selectionEnd = position +=
      target.value.charAt(position - 1) === " " &&
      target.value.charAt(length - 1) === " " &&
      length !== target.value.length
        ? 1
        : 0;
  }

  insertSecretSimulation(number) {
    let _ = this;
    if (number == undefined || number == "" || number == null) {
      _.showCvvCard = "";
      return;
    }
    if (number.toString().length == 1) {
      _.showCvvCard = "X";
      return;
    }
    if (number.toString().length == 2) {
      _.showCvvCard = "XX";
      return;
    }
    if (number.toString().length == 3) {
      _.showCvvCard = "XXX";
      return;
    }
    if (number.toString().length == 4) {
      _.showCvvCard = "XXXX";
      return;
    }
  }

  insertNumberHolder(e) {
    let _ = this;
    let cardNumberLength;
    let subStringFourDigits;
    let cardPlaceholder = "X";
    let blockOfNumber = [];
    let copyPasteCard = true;

    if (_.transactionCardNumber != undefined) {
      cardNumberLength = _.transactionCardNumber.toString().length;
    }

    if (cardNumberLength > 12) {
      subStringFourDigits = _.transactionCardNumber
        .toString()
        .substring(12, 16);
      document.querySelector(
        ".secretNumberBlockFour"
      ).innerHTML = subStringFourDigits;
      if (copyPasteCard) {
        document.querySelector(
          ".secretNumberBlockOne"
        ).innerHTML = cardPlaceholder.repeat(4);
        document.querySelector(
          ".secretNumberBlockTwo"
        ).innerHTML = cardPlaceholder.repeat(4);
        document.querySelector(
          ".secretNumberBlockThree"
        ).innerHTML = cardPlaceholder.repeat(4);
      }
      return;
    }

    if (cardNumberLength > 8) {
      copyPasteCard = false;
      document.querySelector(
        ".secretNumberBlockThree"
      ).innerHTML = cardPlaceholder.repeat(cardNumberLength - 8);
      if (
        (<HTMLElement>document.querySelector(".secretNumberBlockFour"))
          .innerText.length == 1 &&
        e.keyCode == 8
      ) {
        document.querySelector(
          ".secretNumberBlockFour"
        ).innerHTML = cardPlaceholder.repeat(0);
      }
      return;
    }

    if (cardNumberLength <= 4) {
      copyPasteCard = false;
      document.querySelector(
        ".secretNumberBlockOne"
      ).innerHTML = cardPlaceholder.repeat(cardNumberLength);
      if (
        (<HTMLElement>document.querySelector(".secretNumberBlockOne")).innerText
          .length == 1 &&
        e.keyCode == 8
      ) {
        document.querySelector(
          ".secretNumberBlockOne"
        ).innerHTML = cardPlaceholder.repeat(0);
      }
      if (
        (<HTMLElement>document.querySelector(".secretNumberBlockTwo")).innerText
          .length == 1 &&
        e.keyCode == 8
      ) {
        document.querySelector(
          ".secretNumberBlockTwo"
        ).innerHTML = cardPlaceholder.repeat(0);
      }
      return;
    }

    if (cardNumberLength >= 5) {
      copyPasteCard = false;
      document.querySelector(
        ".secretNumberBlockTwo"
      ).innerHTML = cardPlaceholder.repeat(cardNumberLength - 4);
      if (
        (<HTMLElement>document.querySelector(".secretNumberBlockThree"))
          .innerText.length == 1 &&
        e.keyCode == 8
      ) {
        document.querySelector(
          ".secretNumberBlockThree"
        ).innerHTML = cardPlaceholder.repeat(0);
      }
      return;
    }
  }

  cardDigits() {
    let _ = this;
    if (
      _.transactionCardNumber == undefined ||
      _.transactionCardNumber == null
    ) {
      return;
    }
    if (_.transactionCardNumber.toString().length > 16) {
      _.transactionCardNumber = _.transactionCardNumber
        .toString()
        .substr(0, 16);
    }
  }

  expirationMonthDigits() {
    let _ = this;
    if (_.transactionExpMonth > 12) {
      if (_.englishProdh == true || _.assetLenguageEs == false) {
        _.customError = "Invalid expiration month";
        return;
      }
      _.customError = "Mes de expiración inválido";
    }
    if (
      _.transactionExpMonth == undefined ||
      _.transactionExpMonth == undefined
    ) {
      return;
    }
    _.customError = "";
    if (_.transactionExpMonth.toString().length > 2) {
      _.transactionExpMonth = _.transactionExpMonth.toString().substr(0, 2);
      return;
    }
  }

  expirationYearDigits() {
    let _ = this;
    let t = new Date().getFullYear().toString().split("0")[1];
    if (_.transactionExpYear <= parseInt(t)) {
      if (_.englishProdh == true || _.assetLenguageEs == false) {
        _.customError = "Invalid expiration year";
        return;
      }
      _.customError = "Año de expiración inválido";
    }
    _.customError = "";
    if (
      _.transactionExpYear == undefined ||
      _.transactionExpYear == undefined
    ) {
      return;
    }
    if (_.transactionExpYear.toString().length > 2) {
      _.transactionExpYear = _.transactionExpYear.toString().substr(0, 2);
      return;
    }
  }

  documentType() {
    let _ = this;
    let conditions = {
      conditions: {},
      merchant: _.merchant,
    };
    _.apiRequestsService.documentType(conditions).subscribe(
      (data) => {
        _.documentTypeOptions = data["results"];
      },
      (error) => {}
    );
  }

  closeAreYouSureMessange() {
    const _ = this;
    location.href = `/${_.merchant}`;
  }

  /* All Analytics By Merchant */
  addUneteAnalyticsScript() {
    const _ = this;
    if (_.getMerchant === "uneteaffi" && env.production) {
      const head = document.getElementsByTagName("head")[0];
      const script = document.createElement("script");
      script.src = "https://www.googletagmanager.com/gtag/js?id=UA-9407308-1";
      script.type = "text/javascript";
      head.appendChild(script);
    }
  }

  addUneteAnalyticsTracker() {
    const _ = this;
    if (_.getMerchant === "uneteaffi" && env.production) {
      // Regular Analytics Script
      let head = document.getElementsByTagName("head")[0];
      let script = document.createElement("script");
      script.type = "text/javascript";
      script.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'UA-9407308-1');
      `;
      head.appendChild(script);
      // GTAG - Event snippet for Conversion-donacion
      head = document.getElementsByTagName("head")[0];
      script = document.createElement("script");
      script.type = "text/javascript";
      script.innerHTML = `
        window.addEventListener('DOMContentLoaded', function () {
          gtag('event', 'envio', {
            'event_category': 'donacion'
          });
        });
      `;
      head.appendChild(script);
    }
  }

  private generateToken(): void {
    const now = moment().utc().format("YYYY-MM-DD HH");
    const merchantKey: any = crypto.AES.encrypt(this.merchant, env.accessKey);
    const time = crypto.AES.encrypt(now, env.accessKey);
    this.authTokenAccess = btoa(merchantKey + ":" + time);
  }

}
